import React from 'react';
import SignUp from '../components/auth/SignUp';

const SignUpPage = () => <SignUp />;

export default SignUpPage;
